// Main data
export const PROVINSI = "PROVINSI";
export const KABUPATEN = "KABUPATEN";
export const KECAMATAN = "KECAMATAN";
export const KELURAHAN = "KELURAHAN";

// Document Report (DC)
export const DC_COMP_TYPE = "DC_COMP_TYPE";
export const DC_COMPANY = "DC_COMPANY";
export const DC_REPORT_TYPE = "DC_REPORT_TYPE";
export const DC_YEAR = "DC_YEAR";
export const DC_KUARTAL = "DC_KUARTAL";
export const DC_DATA = "DC_DATA";

// Finance Filter
export const FI_YEAR = "FI_YEAR";
export const FI_MONTH = "FI_MONTH";
export const FI_PERUSAHAAN = "FI_PERUSAHAAN";

// filter kinerja
export const KI_YEAR = "KI_YEAR";
export const KI_PERUSAHAAN = "KI_PERUSAHAAN";
export const KI_KUARTAL = "KI_KUARTAL";
export const KI_TYPE = "KI_TYPE";
export const KI_DATA = "KI_DATA";

// pegawai
export const PG_DATA = "PG_DATA";
export const PG_SELECTED = "PG_SELECTED";
export const PG_ALAMAT = "PG_ALAMAT";
export const PG_KELURAHAN = "PG_KELURAHAN";
export const PG_MULAIKERJA = "PG_MULAIKERJA";
export const PG_POSISI = "PG_POSISI";
export const PG_TINGKAT = "PG_TINGKAT";
export const PG_DIVISI = "PG_DIVISI";
export const PG_DEPARTEMEN = "PG_DEPARTEMEN";
export const PG_PERFORMA = "PG_PERFORMA";
export const PG_TALENT = "PG_TALENT";
export const PG_PENGEMBANGAN = "PG_PENGEMBANGAN";
export const PG_NIK = "PG_NIK";
export const PG_NAMA = "PG_NAMA";
export const PG_TEMPAT_LAHIR = "PG_TEMPAT_LAHIR";
export const PG_TANGGAL_LAHIR = "PG_TANGGAL_LAHIR";
export const PG_SMP = "PG_SMP";
export const PG_SMA = "PG_SMA";
export const PG_S1 = "PG_S1";
export const PG_S2 = "PG_S2";
export const PG_S3 = "PG_S3";

// daftar aset
export const PG_NAMA_ASET = "PG_NAMA_ASET";
export const PG_ALAMAT_ASET = "PG_ALAMAT_ASET";
export const PG_TANAH_BANGUNAN = "PG_TANAH_BANGUNAN";
export const PG_LUAS_TANAH = "PG_LUAS_TANAH";
export const PG_LUAS_BANGUNAN = "PG_LUAS_BANGUNAN";
export const PG_STATUS_ASET = "PG_STATUS_ASET";
export const PG_KETERANGAN = "PG_KETERANGAN";
export const PG_PERUSAHAAN_ID = "PG_PERUSAHAAN_ID";
export const PG_KOORDINAT = "PG_KOORDINAT";
export const PG_LONGITUDE = "PG_LONGITUDE";
export const PG_LATITUDE = "PG_LATITUDE";
export const PG_CREATE_BY_ID = "PG_CREATE_BY_ID";
export const PG_APPROVED_BY_ID = "PG_APPROVED_BY_ID";
export const PG_UPDATED_BY_ID = "PG_UPDATED_BY_ID";
export const PG_REJECTED_BY_ID = "PG_REJECTED_BY_ID";
export const PG_CREATE_AT = "PG_CREATE_AT";
export const PG_APPROVED_AT = "PG_APPROVED_AT";
export const PG_UPDATED_AT = "PG_UPDATED_AT";
export const PG_REJECTED_AT = "PG_REJECTED_AT";
